import { useState, useCallback, ReactNode } from "react";
import { ResizeSensor as ResizeSensorComponent } from "@blueprintjs/core";

export type SizeType = {
  height: number;
  width: number;
};
export interface ResizeSensorProps {
  children: (size: SizeType, ready: boolean) => ReactNode;
}

const ResizeSensor = ({ children }: ResizeSensorProps) => {
  const [ready, setReady] = useState(false);
  const [size, setSize] = useState<SizeType>({ height: 0, width: 0 });

  const handleResize = useCallback(
    ([{ contentRect }]: ResizeObserverEntry[]) => {
      setSize({
        width: Math.floor(contentRect.width),
        height: Math.floor(contentRect.height),
      });
      setTimeout(() => {
        setReady(true);
      }, 10);
    },
    [setSize]
  );
  return (
    <ResizeSensorComponent onResize={handleResize}>
      {children(size, ready)}
    </ResizeSensorComponent>
  );
};

export default ResizeSensor;
